(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var accordionItems = document.querySelectorAll('.product-accordion-item');

  accordionItems.forEach(function(item) {
    var title = item.querySelector('.product-accordion-title');
    var content = item.querySelector('.product-accordion-content');

    var isContentOpen = false;

    title.addEventListener('click', function() {
      // Close all accordions
      accordionItems.forEach(function(otherItem) {
        var otherContent = otherItem.querySelector('.product-accordion-content');
        otherContent.style.maxHeight = '0';
        otherItem.classList.remove('open'); // Remove the 'open' class
      });

      if (isContentOpen) {
        content.style.maxHeight = '0';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        item.classList.add('open'); // Add the 'open' class
      }

      isContentOpen = !isContentOpen;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  var accordionItems = document.querySelectorAll('.product-accordion-item');

  accordionItems.forEach(function(item) {
    var title = item.querySelector('.product-accordion-title');
    var content = item.querySelector('.product-accordion-content');

    var isContentOpen = false;

    title.addEventListener('click', function() {
      // Close all accordions
      accordionItems.forEach(function(otherItem) {
        var otherContent = otherItem.querySelector('.product-accordion-content');
        otherContent.style.maxHeight = '0';
        otherItem.classList.remove('open'); // Remove the 'open' class
      });

      if (isContentOpen) {
        content.style.maxHeight = '0';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        item.classList.add('open'); // Add the 'open' class
      }

      isContentOpen = !isContentOpen;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
